import _ from 'lodash';

/**
 * Checks to see if a vehicle's pricing data falls within the bounds of a provided price range.
 *
 * @param {number} priceRange.min
 * @param {number} priceRange.max
 * @param {number} vehicle.priceRange.low
 * @param {number} vehicle.priceRange.high
 * @param {number} vehicle.newPrice
 */
// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'priceRange' implicitly has an 'any' type.
const isVehicleInPriceRange = (priceRange, vehicle) => {
  // Check if vehicle has a priceRange defined
  if (_.some(vehicle.priceRange, (price) => price > 0)) {
    if (_.get(vehicle, 'priceRange.low') <= priceRange.max && priceRange.min <= _.get(vehicle, 'priceRange.high')) {
      return true;
    }
  } else if (_.get(vehicle, 'newPrice') > priceRange.min && _.get(vehicle, 'newPrice') <= priceRange.max) {
    return true;
  }

  return false;
};

export default isVehicleInPriceRange;
